import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomizedTables from "../component/CustomizedTables";
import { useEffect, useState } from "react";
import axios from "axios";
import { ACCOUNT_GET, ACCOUNT_SAVE } from "../apis/Endpoint";
const columns = [
  { label: 'Sno', key: 'sno' },
  { label: 'Account Name', key: 'accountName' },
  { label: 'User Name', key: 'userName', align: 'left' },
  { label: 'Account Type', key: 'accountType', align: 'right' },
  { label: 'Basic Amount', key: 'basicAmount', align: 'right' },
  { label: 'Status', key: 'status', align: 'right' },
];

const Account = () => {
  const [account, setAccount] = useState({
    accountName: "",
    userName: "",
    accountType: "",
    basicAmount: 0,
    status: ""
  });

  const [accountList, setAccountList] = useState([])

  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    const { value, name } = event.target;
    setAccount({ ...account, [name]: value });
  }

  const handleAdd = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false)
  }

  const getAccount = () => {
    axios.get(ACCOUNT_GET).then((res) => {
      setAccountList(res.data.data);
    })
  }

  useEffect(() => {
    getAccount()
  }, [])

  const handleSubmit = () => {
    axios.post(ACCOUNT_SAVE, account)  // Correct endpoint URL for backend
      .then((res) => {
        if (res.data.message === "Account added successfully") {
          getAccount();
        } else {
          alert(res.data.message); // Alert if there's an error
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }


  return (
    <Box sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: 'column',
      pl: 2,
      boxSizing: 'border-box',
      pr: 1,
      alignItems: "center",
      justifyContent: "start"
    }}>


      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>New Account</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2 }}>

            <TextField
              label="Account Name"
              name="accountName"
              value={account.accountName}
              type="text"
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "purple"
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "purple"
                  }
                }
              }}
            />

            <TextField
              label="User Name"
              name="userName"
              type="text"
              value={account.userName}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "purple"
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "purple"
                  }
                }
              }}
            />

            <FormControl fullWidth>
              <InputLabel sx={{ color: "purple" }}>Account Type</InputLabel>
              <Select
                value={account.accountType}
                name="accountType"
                label="Account Type"
                onChange={handleChange}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "purple"
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "purple"
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "purple"
                  }
                }}
              >
                <MenuItem value="Savings">Savings</MenuItem>
                <MenuItem value="Current">Current</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Basic Amount"
              name="basicAmount"
              type="text"
              value={account.basicAmount}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "purple"
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "purple"
                  }
                }
              }}
            />

            <FormControl fullWidth>
              <InputLabel sx={{ color: "purple" }}>Status</InputLabel>
              <Select
                value={account.status}
                label="Status"
                name="status"
                onChange={handleChange}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "purple"
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "purple"
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "purple"
                  }
                }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Deactive">Deactive</MenuItem>
              </Select>
            </FormControl>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
      <Box sx={{
        width: "100%",
        height: "10vh",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold', color: '#8e24aa' }}>Account</Typography>
        <Button
          variant="contained"
          size="small"
          onClick={handleAdd}
          sx={{
            backgroundColor: "#8e24aa",
            "&:hover": {
              backgroundColor: "darkviolet"
            },
            borderRadius: "8px" // optional: makes the button look softer
          }}
        >
          +ADD
        </Button>
      </Box>
      <CustomizedTables rows={accountList} columns={columns} />
    </Box>
  );
}

export default Account;
